import * as React from 'react'

import { Box, type Dimensions } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  gap?: Dimensions
  open: boolean
}

function Item(node: React.ReactNode, index: number) {
  return (
    <Box key={index} component="li" overflowY="hidden" overflowX="hidden">
      {node}
    </Box>
  )
}

function ExplotableDropdown({ children, gap, open }: React.PropsWithChildren<Props>) {
  return (
    <Box gap={gap} component="ul">
      {open && React.Children.map(children, Item)}
    </Box>
  )
}

export default observer(ExplotableDropdown)
